import { getCatalogueLabels } from './api';

export const CATALOGUE_LABELS = {
  cacheKey: 'CATALOGUE_LABELS',
  apiFunction: getCatalogueLabels
};
